import FixedStrikeZone from "./FixedStrikeZone.js";
import TrueStrikeZone from "./TrueStrikeZone.js";

/**
 * Umpire decision is often based on some kind of universal strike zone, which is not adjusted for a taller batters.
 * This leads to solution based on universal strike zone, especially when pitcher data is being analyzed. 
 * We will try to adopt similar universal strike zone model for Fast Pitch Softball
 * @see https://www.slideserve.com/Rita/fast-pitch-strike-zone
 * @see https://flightscope.atlassian.net/browse/BBP-893
 * @see https://image3.slideserve.com/6681792/the-book-strike-zone-2-56-4-l.jpg
 * @see https://docs.google.com/document/d/1GCQVVh6Ue0DrSiaHLYZ4zasDBxZSEi6kYt1aHgD_afo/edit#heading=h.l38dodwvtpxy
 * @see https://docs.google.com/document/d/1AP6qx2Y64D2CwIlOF_XzgDcUWDWQLfI1TCCBGx0GDko/edit#
 * @see http://tangotiger.net/strikezone/zone%20chart.png
 */
class UniversalStrikeZoneFastPitch extends FixedStrikeZone{
    constructor(){
        const strikeZoneBottom = 18 * 0.0254;
        const strikeZoneTop = 42 * 0.0254;
        const strikeZoneWidth = 20 * 0.0254;

        super(strikeZoneWidth, strikeZoneBottom, strikeZoneTop);
    }
}

export default UniversalStrikeZoneFastPitch;